// tslint:disable: max-line-length
// import { RebuscaComponent } from './../../app/turismo/rebusca/rebusca.component';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { __read, __spreadArrays } from 'tslib';
import { Cidade, Pais } from './../endereco.model';
import { Aereo, BuscaAereoRQ } from './aereo.model';
import { Aeroporto } from './aeroporto.model';
import { BuscaBetoCarreroRQ } from './beto-carrero.model';
import { BuscaCarroRQ, LojasCarros } from './carro.model';
import { BuscaHotelRQ } from './hotel.model';
import { BuscaPacoteRQ } from './pacote.model';
import { BuscaServicoRQ } from './servico.model';
import { addOrSubtractDays, toDateTime } from 'src/app/utils/luxon.helper';
import { DateTime } from 'luxon';
import { BuscarCircuitoRQ } from './circuito.model';

export enum TIPOBUSCAAEREO {
    idaVolta = 'ida-volta',
    ida = 'ida',
    surface = 'surface',
    multiplosTrechos = 'multiplos-trechos'
}

export class Opcoes {
    public gol = true;
    public azul = true;
    public amadeus = true;
    public sabre = true;
    public diretos = false;

    public TodasFamilias = false;
    public resultadosAereos = 9999;
    public resultadosHoteis = 1000;
}

export class Buscas {
    public aereo: boolean;
    public hotel: boolean;
    public ticket: boolean;
    public transfer: boolean;
    public seguro: boolean;
    public produtooffline: boolean;
    public carro: boolean;
    public beto: boolean;
    public circuito: boolean;
    public servicoExclusivo: boolean = false;
}

export class Trecho {
    public cidadeOrigem: Cidade;
    public cidadeDestino: Cidade;
    public AeroportoPartida: Aeroporto;
    public AeroportoChegada: Aeroporto;
    public dataIda: DateTime;
    public dataVolta: DateTime;
    public minDataIda: DateTime;
    public minDataVolta: DateTime;

    constructor() {
        this.cidadeOrigem = new Cidade();
        this.cidadeDestino = new Cidade();
        this.AeroportoPartida = new Aeroporto();
        this.AeroportoChegada = new Aeroporto();
        this.dataIda = toDateTime(new Date());
        this.dataVolta = addOrSubtractDays(this.dataIda, { day: 1 });
        this.minDataIda = this.dataIda;
        this.minDataVolta = this.dataIda;
    }
}

@Injectable()
export class Quarto {
    public qtdeAdultos = 1;
    public qtdeCriancas = 0;
    public qtdeIdosos: number = 0;
    public idadesCriancas: number[] = [];
    public show: any = false;
    public nacionalidadePaxQuarto: any;

    constructor() { }

    adicionarAdulto() {
        if (this.qtdeAdultos > 0) {
            this.qtdeAdultos++;
        }
    }

    removerAdulto() {
        if (this.qtdeAdultos > 1) {
            this.qtdeAdultos--;
        } else {
            alert('Mínimo 1 adulto');
        }
    }

    adicionarCrianca() {
        if (this.qtdeCriancas < 6) {
            this.qtdeCriancas++;
            this.idadesCriancas.push(0);
            console.log(`Adicionando criança: ${this.qtdeCriancas} - Idades: ${this.idadesCriancas}`);
        }
    }

    removerCrianca() {
        if (this.qtdeCriancas > 0) {
            this.qtdeCriancas--;
            this.idadesCriancas.pop();
            console.log(`Removendo criança: ${this.qtdeCriancas} - Idades: ${this.idadesCriancas}`);
        }
    }

    adicionarIdade(quarto, x) {
        if (quarto.idadesCriancas[x] < 17) {
            quarto.idadesCriancas[x]++;
        }
    }

    removerIdade(quarto, x) {
        if (quarto.idadesCriancas[x] > 0) {
            quarto.idadesCriancas[x]--;
        }
    }
}

@Injectable()
export class Busca {
    TIPOBUSCAAEREO(arg0: string) {
        throw new Error('Method not implemented.');
    }
    primeira = true;
    novoOrcamento = true;
    // orcamentoId = 0;
    ReservaId = 0;
    tipoBuscaAereo: TIPOBUSCAAEREO = TIPOBUSCAAEREO.idaVolta;
    tipoBusca: Buscas;
    destinoCodigo = '';
    somenteCarro = false;
    trechos: Trecho[] = [];
    dataVisitaBetoCarrero: DateTime;
    quartos: Quarto[];
    AgenciaId: any;
    opcoesAvancadas: Opcoes;
    AereoConsolidacao = false;
    guid: string;
    guidHotel: string;
    aereo: Aereo;
    nrnoites = 0;
    usuario: any;
    public nacionalidadePax: Pais;
    PacoteId = 0;
    Temporada: any;
    Fornecedores: string[] = ["ST"];

    // Parte carro
    localOrigem = new LojasCarros();
    dataOrigem: DateTime;
    dataDevolucao: DateTime;
    horaOrigem = 10;
    minutoOrigem = 0;
    localDevolucao = new LojasCarros();
    horaDevolucao = 10;
    minutoDevolucao = 0;


    constructor() {
        this.tipoBusca = new Buscas();
        this.opcoesAvancadas = new Opcoes();
        this.quartos = [];
        this.quartos.push(new Quarto());
        this.trechos = [];
        this.trechos.push(new Trecho());
        this.nacionalidadePax = (new Pais());
        this.tipoBuscaAereo = TIPOBUSCAAEREO.idaVolta;
    }

    getQtdeQuartos(): number {
        if (this.quartos !== undefined) {
            return this.quartos.length;
        } else { return 0; }
    }

    getQtdeAdultos(): number {
        let soma = 0;
        if (this.quartos != undefined) {
            for (let i = 0; i < this.quartos.length; i++) {
                soma += this.quartos[i].qtdeAdultos;
                soma += this.quartos[i].qtdeIdosos;
            }
            for (let i = 0; i < this.quartos.length; i++) {
                soma += this.quartos[i].idadesCriancas.filter(x => x > 11).length;
            }
        }
        return soma;
    }
    getQtdeAdultosServico(): number {
        let soma = 0;
        if (this.quartos != undefined) {
            for (let i = 0; i < this.quartos.length; i++) {
                soma += this.quartos[i].qtdeAdultos;
                soma += this.quartos[i].qtdeIdosos;
            }
        }
        return soma;
    }
    getQtdeCriancas(): number {
        let soma = 0;
        if (this.quartos != undefined) {
            for (let i = 0; i < this.quartos.length; i++) {
                soma += this.quartos[i].qtdeCriancas;
            }
        }
        return soma;
    }

    getQtdeChd(): number {
        let soma = 0;
        if (this.quartos != undefined) {
            for (let i = 0; i < this.quartos.length; i++) {
                soma += this.quartos[i].idadesCriancas.filter(x => x > 1 && x < 12).length;
            }
        }
        return soma;
    }

    getQtdeInf(): number {
        let soma = 0;
        if (this.quartos != undefined) {
            for (let i = 0; i < this.quartos.length; i++) {
                soma += this.quartos[i].idadesCriancas.filter(x => x < 2).length;
            }
        }
        return soma;
    }

    getIdadesChdInf(): string {
        let idades = '';
        if (this.quartos != undefined) {
            for (const quarto of this.quartos) {
                const idadesCriancas = quarto.idadesCriancas;
                for (const idade of idadesCriancas) {
                    idades += idade + ',';
                }
            }
        }
        return idades;
    }

    getQtdePessoasPorQuarto(quarto: Quarto): number {
        const adultos = quarto.qtdeAdultos;
        const idosos = quarto.qtdeIdosos;
        const criancas = quarto.qtdeCriancas;
        const soma = adultos + idosos + criancas;
        return soma;
    }

    decodeBusca(json: string): Busca {
        const buscaDecodificada = JSON.parse(json);
        const busca = Object.create(Busca.prototype);
        const quarto = Object.create(Quarto.prototype);

        buscaDecodificada.quartos = buscaDecodificada.quartos.map(x => {
            x = this.AssignQuarto(x);
            return x;
        });

        return Object.assign(busca, buscaDecodificada);
    }

    decodeBuscaNovo(json: string): Busca {
        const buscaDecodificada = JSON.parse(json);
        const busca = Object.create(Busca.prototype);

        buscaDecodificada.quartos = buscaDecodificada.quartos.map(x => {
            x = this.AssignQuarto(x);
            return x;
        });

        return Object.assign(busca, buscaDecodificada);
    }

    decodeBuscaEspecificaPacoteHome(json: string){
        const buscaDecodificada = JSON.parse(json);
        const busca = Object.create(Busca.prototype);

        buscaDecodificada.quartos = buscaDecodificada.quartos.map(x => {
            x = this.AssignQuarto(x);
            return x;
        });

        let buscaObjeto: Busca = Object.assign(busca, buscaDecodificada);

        buscaObjeto.trechos = buscaObjeto.trechos.map(t => {
            const trecho = Object.create(Trecho.prototype);
            t.dataIda = toDateTime(t.dataIda.toString());
            t.dataVolta = toDateTime(t.dataVolta.toString());
            t.minDataIda = toDateTime(t.minDataIda.toString());
            t.minDataVolta = toDateTime(t.minDataVolta.toString());
            return Object.assign(trecho, t);
        });
        buscaObjeto.dataVisitaBetoCarrero = toDateTime(buscaObjeto.dataVisitaBetoCarrero.toString());
        buscaObjeto.dataOrigem = toDateTime(buscaObjeto.dataOrigem?.toString());
        buscaObjeto.dataDevolucao = toDateTime(buscaObjeto.dataDevolucao?.toString());

        return buscaObjeto;
    }

    AssignQuarto(quarto): Quarto {
        let TypeQuarto = Object.create(Quarto.prototype);

        return Object.assign(TypeQuarto, quarto);
    }

    getBuscaHotel(): BuscaHotelRQ {
        const buscaHotel = new BuscaHotelRQ();
        let agencia = localStorage.getItem('g8h7d8');
        if (agencia != null) {
            const agenciaID = JSON.parse(atob(agencia));
            buscaHotel.AgenciaId = agenciaID.Id;
        }
        if (this.ReservaId !== 0) {
            buscaHotel.ReservaId = this.ReservaId;
        }
        buscaHotel.Guid = this.guid;
        buscaHotel.PacoteId = this.PacoteId;

        for (let i = 0; i < this.quartos.length; i++) {
            buscaHotel.Quartos.push({
                NumeroPesquisa: i + 1,
                Qtde: 1,
                Adultos: this.quartos[i].qtdeAdultos,
                Criancas: this.quartos[i].idadesCriancas
            });
        }

        if (this.tipoBusca.aereo && this.primeira) {
            switch (this.tipoBuscaAereo) {
                case TIPOBUSCAAEREO.ida:
                    buscaHotel.Checkin = this.trechos[0].dataIda.toISODate();
                    buscaHotel.Checkout = addOrSubtractDays(this.trechos[0].dataIda, { days: 3 }).toISODate();
                    buscaHotel.Cidade.Id = this.trechos[0].AeroportoChegada.CidadeId;
                    break;

                case TIPOBUSCAAEREO.idaVolta:
                    if (this.primeira && this.aereo !== undefined) {
                        let data = toDateTime(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString());

                        buscaHotel.Checkin = data.hour >= 4 ? data.toISODate() : addOrSubtractDays(data, { days: -1 }).toISODate();

                        if (this.aereo.Fornecedor != "BLA" && this.aereo.SubFornecedor != "BLA") {
                            buscaHotel.Checkout = toDateTime(this.aereo.Seguimentos[1].Voos[0].DataPartida.toString()).toISODate();
                        } else {
                            let Seguimento = this.aereo.Seguimentos[0];

                            buscaHotel.Checkin = toDateTime(Seguimento.DataPartida).toISODate();
                            buscaHotel.Checkout = toDateTime(Seguimento.DataChegada).toISODate();
                        }

                    } else {
                        buscaHotel.Checkin = this.trechos[0].dataIda.toISODate();
                        buscaHotel.Checkout = this.trechos[0].dataVolta.toISODate();
                    }

                    buscaHotel.Cidade.Id = this.trechos[0].AeroportoChegada.CidadeId;
                    buscaHotel.Cidade.Nome = this.trechos[0].cidadeDestino.Nome;
                    buscaHotel.Cidade.CidadeVinculada = this.trechos[0].cidadeDestino.Nome;
                    buscaHotel.Cidade.Estado = this.trechos[0].cidadeDestino.Estado;

                    break;

                case TIPOBUSCAAEREO.multiplosTrechos:
                    if (!this.primeira) {
                        buscaHotel.Checkin = this.trechos[0].dataIda.toISODate();
                    }

                    if (this.trechos.length > 1 && this.aereo != undefined) {
                        let data = toDateTime(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString());
                        buscaHotel.Checkin = data.hour >= 4 ? data.toISODate() : addOrSubtractDays(data, { day: -1 });
                        buscaHotel.Checkout = this.trechos[this.trechos.length - 1].dataIda.toISODate();

                        this.trechos[0].dataVolta = this.trechos[this.trechos.length - 1].dataIda;
                    } else {
                        buscaHotel.Checkout = this.trechos[0].minDataVolta;
                    }

                    buscaHotel.Cidade.Id = this.trechos[0].AeroportoChegada.CidadeId;
                    break;
            }
        } else {
            buscaHotel.Checkin = this.trechos[0].dataIda.toISODate();
            buscaHotel.Checkout = this.trechos[0].dataVolta.toISODate();
            buscaHotel.Cidade.Id = this.trechos[0].cidadeDestino.Id;
            buscaHotel.Cidade.CidadeVinculada = this.trechos[0].cidadeOrigem;
        }

        return buscaHotel;
    }

    getBuscaServico(): BuscaServicoRQ {
        const buscaServico = new BuscaServicoRQ();

        let agencia = localStorage.getItem('g8h7d8');
        if (agencia != null) {
            const agenciaID = JSON.parse(atob(agencia));
            buscaServico.AgenciaId = agenciaID.Id;
        }

        buscaServico.Guid = this.guid;

        if (this.ReservaId == 0) {
            buscaServico.ReservaId = this.ReservaId;
        }

        buscaServico.IdadesChd = [];
        for (const quarto of this.quartos) {
            buscaServico.IdadesChd = __spreadArrays(__read(buscaServico.IdadesChd), __read(quarto.idadesCriancas));

            buscaServico.Adt = this.getQtdeAdultosServico();
        }

        if (this.tipoBusca.aereo) {
            switch (this.tipoBuscaAereo) {
                case TIPOBUSCAAEREO.ida:
                    buscaServico.De = this.trechos[0].dataIda.toISODate();
                    buscaServico.Ate = this.trechos[0].minDataVolta.toISODate();
                    buscaServico.Cidade.Id = this.trechos[0].AeroportoChegada.CidadeId;
                    break;
                case TIPOBUSCAAEREO.idaVolta:
                    if (this.primeira && this.aereo !== undefined) {
                        let data = toDateTime(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString());
                        if (data.hour >= 4) {
                            buscaServico.De = data.toISODate();
                        } else {
                            buscaServico.De = addOrSubtractDays(data, {day: -1});
                        }

                        if (this.aereo.Fornecedor != "BLA") {
                            data = toDateTime(this.aereo.Seguimentos[1].Voos[0].DataPartida.toString());
                            buscaServico.Ate = data.toISODate();
                        } else {
                            let Seguimento = this.aereo.Seguimentos[0];

                            buscaServico.De = toDateTime(Seguimento.DataPartida).toISODate();
                            buscaServico.Ate = toDateTime(Seguimento.DataChegada).toISODate();

                            this.trechos[0].dataIda = toDateTime(buscaServico.De);
                            this.trechos[0].dataVolta = toDateTime(buscaServico.Ate);
                        }

                    } else {
                        buscaServico.De = this.trechos[0].dataIda.toISODate();
                        buscaServico.Ate = this.trechos[0].dataVolta.toISODate();
                    }

                    buscaServico.Cidade.Id = this.trechos[0].AeroportoChegada.CidadeId;
                    buscaServico.Cidade.Nome = this.trechos[0].cidadeDestino.Nome;
                    buscaServico.Cidade.CidadeVinculada = this.trechos[0].cidadeDestino.Nome;
                    buscaServico.Cidade.Estado = this.trechos[0].cidadeDestino.Estado;
                    break;
                case TIPOBUSCAAEREO.multiplosTrechos:
                    if (!this.primeira) {
                        buscaServico.De = this.trechos[0].dataIda.toISODate();
                    }

                    if (this.trechos.length > 1) {
                        const data = toDateTime(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString());
                        if (data.hour >= 4) {
                            buscaServico.De = data;
                        } else {
                            buscaServico.De = addOrSubtractDays(data, { day: -1 });
                        }

                        buscaServico.Ate = this.trechos[this.trechos.length - 1].dataIda.toISODate();
                        this.trechos[0].dataVolta = this.trechos[this.trechos.length - 1].dataIda;
                    } else {
                        buscaServico.Ate = this.trechos[0].minDataVolta.toISODate();
                    }
                    buscaServico.Cidade.Id = this.trechos[0].AeroportoChegada.CidadeId;
                    break;
            }
        } else {
            buscaServico.De = this.trechos[0].dataIda.toISODate();
            buscaServico.Ate = this.trechos[0].dataVolta.toISODate();
            buscaServico.Cidade.Id = this.trechos[0].cidadeDestino.Id;
            buscaServico.Cidade.CidadeVinculada = this.trechos[0].cidadeOrigem;
        }

        return buscaServico;
    }

    getBuscaPacote(): BuscaPacoteRQ {
        const buscaPacote = new BuscaPacoteRQ();
        buscaPacote.AgenciaId = this.AgenciaId;
        buscaPacote.Guid = this.guid;
        buscaPacote.Adt = 0;
        buscaPacote.Chd = 0;
        for (const quarto of this.quartos) {
            buscaPacote.Adt += quarto.qtdeAdultos;
            buscaPacote.Chd += quarto.qtdeCriancas;
        }
        buscaPacote.DestinoCodigo = this.destinoCodigo;

        return buscaPacote;
    }

    getBuscaAereo(): BuscaAereoRQ {
        const buscaAereo = new BuscaAereoRQ();
        if (this.ReservaId === 0) {
            buscaAereo.Adt = this.getQtdeAdultos();
            buscaAereo.Chd = this.getQtdeChd();
            buscaAereo.Inf = this.getQtdeInf();
            buscaAereo.Idades = this.getIdadesChdInf();
        } else {
            buscaAereo.Idades = this.getIdadesChdInf();
            buscaAereo.ReservaId = this.ReservaId;
        }

        let agencia = localStorage.getItem('g8h7d8');
        if (agencia != null) {
            const agenciaID = JSON.parse(atob(agencia));
            buscaAereo.AgenciaId = agenciaID.Id;
        }

        buscaAereo.AereoConsolidacao = this.AereoConsolidacao;
        buscaAereo.MaximoRegistros = this.opcoesAvancadas.resultadosAereos;
        buscaAereo.FiltroAereo.TodasFamilias = !this.opcoesAvancadas.TodasFamilias;
        buscaAereo.FiltroAereo.SomenteVoosDiretos = this.opcoesAvancadas.diretos;
        buscaAereo.SegmentosBusca = [];
        buscaAereo.TipoBusca = this.tipoBuscaAereo;

        if (this.tipoBuscaAereo === TIPOBUSCAAEREO.idaVolta) {
            const x = this.trechos[0];
            buscaAereo.SegmentosBusca.push({
                AeroportoPartida: x.AeroportoPartida.Iata,
                AeroportoChegada: x.AeroportoChegada.Iata,
                PaisChegada: null,
                DataPartida: x.dataIda.toISODate()
            });
            buscaAereo.SegmentosBusca.push({
                AeroportoPartida: x.AeroportoChegada.Iata,
                AeroportoChegada: x.AeroportoPartida.Iata,
                PaisChegada: null,
                DataPartida: x.dataVolta.toISODate()
            });
        } else {
            for (const trecho of this.trechos) {
                buscaAereo.SegmentosBusca.push({
                    AeroportoPartida: trecho.AeroportoPartida.Iata,
                    AeroportoChegada: trecho.AeroportoChegada.Iata,
                    PaisChegada: trecho.AeroportoChegada.Cidade.Estado.Pais,
                    DataPartida: trecho.dataIda.toISODate()
                });
            }
        }

        buscaAereo.Guid = this.guid;

        return buscaAereo;
    }

    getBuscaCarro(): BuscaCarroRQ {
        const buscaCarro = new BuscaCarroRQ();
        buscaCarro.AgenciaId = this.AgenciaId;
        buscaCarro.Guid = this.guid;
        buscaCarro.LocalOrigem = this.localOrigem.Sigla;
        buscaCarro.LocalDevolucao = this.localDevolucao.Sigla;

        if (this.tipoBusca.aereo) {
            switch (this.tipoBuscaAereo) {
                case TIPOBUSCAAEREO.ida:
                    if (!this.primeira) {
                        buscaCarro.DataHoraOrigem = this.trechos[0].dataIda;
                    }
                    buscaCarro.LocalOrigem = this.trechos[0].AeroportoChegada.Iata;
                    buscaCarro.LocalDevolucao = this.trechos[0].AeroportoChegada.Iata;
                    buscaCarro.DataHoraDevolucao = this.trechos[0].minDataVolta;
                    break;
                case TIPOBUSCAAEREO.idaVolta:
                    if (this.primeira && this.aereo !== undefined) {
                        let data = moment(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString(), 'YYYY-MM-DD HH:mm');
                        if (data.hour() >= 4) {
                            buscaCarro.DataHoraOrigem = toDateTime(data.toISOString());
                        } else {
                            buscaCarro.DataHoraOrigem = toDateTime(data.subtract(1, 'day').toISOString());
                        }
                        data = moment(this.aereo.Seguimentos[1].Voos[0].DataPartida.toString(), 'YYYY-MM-DD HH:mm');
                        buscaCarro.DataHoraDevolucao = toDateTime(data.toISOString());
                    } else {
                        buscaCarro.DataHoraOrigem = this.trechos[0].dataIda;
                        buscaCarro.DataHoraDevolucao = this.trechos[0].dataVolta;
                    }
                    buscaCarro.LocalOrigem = this.trechos[0].AeroportoChegada.Iata;
                    buscaCarro.LocalDevolucao = this.trechos[0].AeroportoChegada.Iata;
                    break;
                case TIPOBUSCAAEREO.surface:
                    if (!this.primeira) {
                        buscaCarro.DataHoraOrigem = this.trechos[0].dataIda;
                    }
                    if (this.trechos.length > 1) {
                        const data = moment(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString(), 'YYYY-MM-DD HH:mm');
                        if (data.hour() >= 4) {
                            buscaCarro.DataHoraOrigem = toDateTime(data.toISOString());
                        } else {
                            buscaCarro.DataHoraOrigem = toDateTime(data.subtract(1, 'day').toISOString());
                        }
                        buscaCarro.DataHoraDevolucao = this.trechos[this.trechos.length - 1].dataIda;
                        this.trechos[0].dataVolta = this.trechos[this.trechos.length - 1].dataIda;
                    } else {
                        buscaCarro.DataHoraDevolucao = this.trechos[0].minDataVolta;
                    }
                    buscaCarro.LocalOrigem = this.trechos[0].AeroportoChegada.Iata;
                    buscaCarro.LocalDevolucao = this.trechos[0].AeroportoChegada.Iata;

                    break;
                case TIPOBUSCAAEREO.multiplosTrechos:
                    if (!this.primeira) {
                        buscaCarro.DataHoraOrigem = this.trechos[0].dataIda;
                    }
                    if (this.trechos.length > 1) {
                        const data = moment(this.aereo.Seguimentos[0].Voos[this.aereo.Seguimentos[0].Voos.length - 1].DataChegada.toString(), 'YYYY-MM-DD HH:mm');
                        if (data.hour() >= 4) {
                            buscaCarro.DataHoraOrigem = toDateTime(data.toISOString());
                        } else {
                            buscaCarro.DataHoraOrigem = toDateTime(data.subtract(1, 'day').toISOString());
                        }
                        buscaCarro.DataHoraDevolucao = this.trechos[this.trechos.length - 1].dataIda;
                        this.trechos[0].dataVolta = this.trechos[this.trechos.length - 1].dataIda;
                    } else {
                        buscaCarro.DataHoraDevolucao = this.trechos[0].minDataVolta;
                    }

                    buscaCarro.LocalOrigem = this.trechos[0].AeroportoChegada.Iata;
                    buscaCarro.LocalDevolucao = this.trechos[0].AeroportoChegada.Iata;

                    break;
            }

            buscaCarro.DataHoraOrigem = buscaCarro.DataHoraOrigem.plus({ hours: this.horaOrigem, minutes: this.minutoOrigem });
            buscaCarro.DataHoraDevolucao = buscaCarro.DataHoraDevolucao.plus({ hours: this.horaDevolucao, minutes: this.minutoDevolucao });
        } else if (this.tipoBusca.hotel || this.tipoBusca.ticket) {

            buscaCarro.LocalOrigem = this.trechos[0].AeroportoChegada.Iata;
            buscaCarro.LocalDevolucao = this.trechos[0].AeroportoChegada.Iata;

            buscaCarro.DataHoraOrigem = this.trechos[0].dataIda.plus({ hours: this.horaOrigem, minutes: this.minutoOrigem });
            buscaCarro.DataHoraDevolucao = this.trechos[0].dataVolta.plus({ hours: this.horaDevolucao, minutes: this.minutoDevolucao });
        } else {

            buscaCarro.LocalOrigem = this.localOrigem.Sigla;
            buscaCarro.LocalDevolucao = this.localDevolucao.Sigla;

            buscaCarro.DataHoraOrigem = this.dataOrigem.plus({ hours: this.horaOrigem, minutes: this.minutoOrigem });
            buscaCarro.DataHoraDevolucao = this.dataDevolucao.plus({ hours: this.horaDevolucao, minutes: this.minutoDevolucao });
        }

        this.dataOrigem = buscaCarro.DataHoraOrigem;
        this.dataDevolucao = buscaCarro.DataHoraDevolucao;

        return buscaCarro;
    }

    getBuscaBetoCarrero(): BuscaBetoCarreroRQ {
        const buscaBetoCarreroRQ = new BuscaBetoCarreroRQ();
        buscaBetoCarreroRQ.AgenciaId = this.AgenciaId;
        buscaBetoCarreroRQ.DataPrevista = this.dataVisitaBetoCarrero;
        buscaBetoCarreroRQ.CodProdutos = null;
        buscaBetoCarreroRQ.EstadosEscolhidos = null;

        return buscaBetoCarreroRQ;
    }

    getBuscaCircuito(): BuscarCircuitoRQ {
        const buscarCircuitoRQ = new BuscarCircuitoRQ();
        buscarCircuitoRQ.AgenciaId = this.AgenciaId;
        buscarCircuitoRQ.Guid = this.guid;
        buscarCircuitoRQ.Fornecedores = this.Fornecedores;
        if (this.Temporada) {
            buscarCircuitoRQ.Temporada = this.Temporada;
        }
        buscarCircuitoRQ.Cidade.Id = this.trechos[0].cidadeDestino.Id;
        return buscarCircuitoRQ;
    }
}
